import React, { Component } from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/Footer.css";

class Confirmation extends Component {
  state = {};
  render() {
    return (
      <div>
        <Navbar />
        <Header />
        <div className="container">
          <p className="lead mb-5">
            {this.props.isRegistered &&
              "Sus votos han sido guardados. Enviaremos un enlace de confirmación para validar la autenticidad de tus votos, si no llega a encontrarlo por favor revise en su carpeta de SPAM."}
            {this.props.isSubcuenta &&
              "Detectamos que estás usando una subcuenta. Sólo se puede votar una vez con la misma dirección de correo."}
            {this.props.hasVoted &&
              "Esta cuenta de correo ya emitió sus votos."}
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Confirmation;
